import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
declare var $:any;

@Component({
  selector: 'app-home-gallery',
  templateUrl: './home-gallery.component.html',
  styleUrls: ['./home-gallery.component.scss'],
})
export class HomeGalleryComponent implements OnInit, OnDestroy {
  sub: Subscription;
  
  album1Title: string = 'Convocation';
  album2Title: string = 'Annual Function';
  album3Title: string = 'Sports Day';

  convocation: any[] = [
    '/assets/img/spotlight/convocation1.jpg',
    '/assets/img/spotlight/convocation2.jpg',
    '/assets/img/spotlight/convocation3.jpg',
    '/assets/img/spotlight/convocation4.jpg',
  ];
  annual: any[] = [
    '/assets/img/spotlight/annual1.jpg',
    '/assets/img/spotlight/annual2.jpg',
    '/assets/img/spotlight/annual3.jpg',
    '/assets/img/spotlight/annual4.jpg',
    '/assets/img/spotlight/annual5.JPG',
  ];
  sports: any[] = [
    '/assets/img/spotlight/sports1.jpeg',
    '/assets/img/spotlight/sports2.jpeg',
    '/assets/img/spotlight/sports3.jpeg',
    '/assets/img/spotlight/sports4.jpeg',
  ];

  constructor(private galleryService: GalleryService) {}

  getIconClass(title: string): string {
    const t = title.toLowerCase();
    if (t.includes('convocation') || t.includes('grad') || t.includes('degree')) {
      return 'fa-solid fa-graduation-cap';
    }
    if (t.includes('sport') || t.includes('athlet') || t.includes('game') || t.includes('play')) {
      return 'fa-solid fa-running';
    }
    return 'fa-solid fa-users-rectangle';
  }

  ngOnInit(): void {
    $('#convocation-btn').addClass('active');
    $('#convocation').collapse('show');

    this.galleryService.getGalleryList();
    this.sub = this.galleryService.galleryList.snapshotChanges().subscribe((list) => {
      const items = list.map((item) => {
        const data = item.payload.val() || {};
        const rawUrls = data.imgUrl || data.url || data.image || data.imageUrl || '';
        const imgUrls = Array.isArray(rawUrls) ? rawUrls : (rawUrls ? [rawUrls] : []);
        
        return {
          $key: item.key,
          caption: data.caption || data.title || data.name || data.category || 'Gallery Album',
          category: data.category || '',
          imgUrl: imgUrls
        };
      });

      if (items.length > 0) {
        // Group individual images by category/caption so they cluster into nice multi-image albums
        const groupedMap = new Map<string, { $key: string, caption: string, imgUrl: string[] }>();
        
        items.forEach((item) => {
          const groupKey = item.caption.trim().toLowerCase();
          
          if (groupedMap.has(groupKey)) {
            const existing = groupedMap.get(groupKey)!;
            item.imgUrl.forEach((u: string) => {
              if (u && !existing.imgUrl.includes(u)) {
                existing.imgUrl.push(u);
              }
            });
          } else {
            groupedMap.set(groupKey, {
              $key: item.$key,
              caption: item.caption,
              imgUrl: [...item.imgUrl]
            });
          }
        });

        const albums = Array.from(groupedMap.values()).reverse();
        
        // Map the latest 3 albums dynamically
        if (albums.length > 0) {
          this.album1Title = albums[0].caption;
          this.convocation = albums[0].imgUrl;
        }
        if (albums.length > 1) {
          this.album2Title = albums[1].caption;
          this.annual = albums[1].imgUrl;
        }
        if (albums.length > 2) {
          this.album3Title = albums[2].caption;
          this.sports = albums[2].imgUrl;
        }
      }
    });
  }

  showCard(id: number) {
    if (id === 1) {
      $('#convocation').collapse('show');
      $('#annual').collapse('hide');
      $('#sports').collapse('hide');

      $('#convocation-btn').addClass('active');
      $('#annual-btn').removeClass('active');
      $('#sports-btn').removeClass('active');
    }
    if (id === 2) {
      $('#convocation').collapse('hide');
      $('#annual').collapse('show');
      $('#sports').collapse('hide');

      $('#convocation-btn').removeClass('active');
      $('#annual-btn').addClass('active');
      $('#sports-btn').removeClass('active');
    }
    if (id === 3) {
      $('#convocation').collapse('hide');
      $('#annual').collapse('hide');
      $('#sports').collapse('show');

      $('#convocation-btn').removeClass('active');
      $('#annual-btn').removeClass('active');
      $('#sports-btn').addClass('active');
    }
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
